import React from "react";
import CoachingStatusModule from "../modules/CoachingStatusModule";
import { findNextPendingSession } from "../utils/sessionHelper";

export default function PlatinumCoachingSessionCard({ data, onBookingAction }) {
  const { sessions, role } = data;

  if (!sessions?.length) return null;

  const ownSessions = sessions.filter((s) => s.isOwnSession);
  const employeeSessions = sessions.filter((s) => !s.isOwnSession);

  const nextIndividualSession = findNextPendingSession(sessions, role);

  return (
    <>
      <CoachingStatusModule
        role={role}
        ownSessions={ownSessions}
        employeeSessions={employeeSessions}
        nextIndividualSession={nextIndividualSession}
        onBookingAction={onBookingAction}
      />
    </>
  );
}
